<template>

  <b-table striped :items="items" :fields="fields">
  </b-table>

</template>

<script>

export default {
  name: 'LaborRegistryTable',
  props: {
    items: {type: Array, required: true}
  },
  data() {
    return {
      fields: [
        {key: 'date', label: 'Fecha'},
        {key: 'employeeName', label: 'Operario'},
        {key: 'timeText', label: 'Horas de trabajo'},
        {key: 'pauseText', label: 'Horas de pausa'},
        {key: 'ordinaryHours', label: 'Horas ordinarias'},
        {key: 'overtimeHours', label: 'Horas extra'},
        {key: 'pauseHours', label: 'Horas pausa'},
        {key: 'authorDeviceId', label: 'ID dispositivo'}
      ]
    }
  },
  methods: {
  }
}

</script>

<style lang="scss" scoped>
  .small-font {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/laborRegistry/partials/LaborRegistryTable.vue